module.exports = {
	"id": "KG",
	"name": "Kyrgyzstan",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.211668,
			"5": 0.13656,
			"6": 0.054624,
			"7": 0.150216,
			"8": 0.129732,
			"9": 0.047796,
			"10": 0.047796,
			"11": 0.13656,
			"12": 0.191184,
			"13": 0.116076,
			"14": 0.23898,
			"15": 0.286776,
			"16": 0.1707,
			"17": 0.389196,
			"18": 0.396024,
			"19": 0.191184,
			"20": 0.1707,
			"21": 0.368712,
			"22": 0.122904,
			"23": 0.286776,
			"24": 0.116076,
			"25": 0.20484,
			"26": 0.20484,
			"27": 0.1707,
			"28": 0.095592,
			"29": 0.047796,
			"30": 0.06828,
			"31": 0.047796,
			"32": 0.075108,
			"33": 0.020484,
			"34": 0.040968,
			"35": 0.20484,
			"36": 0.088764,
			"37": 0.10242,
			"38": 0.157044,
			"39": 0.163872,
			"40": 0.402852,
			"41": 0.122904,
			"42": 0.163872,
			"43": 0.279948,
			"44": 0.088764,
			"45": 0.116076,
			"46": 0.03414,
			"47": 0.259464,
			"48": 0.157044,
			"49": 1.290492,
			"50": 0.122904,
			"51": 0.423336,
			"52": 0.559896,
			"53": 20.92782,
			"54": 6.705096,
			"55": 0.20484,
			"56": 0.06828,
			"57": null
		},
		"firefox": {
			"2": 0.184356,
			"3": 0.430164,
			"4": 0.06828,
			"5": 0.095592,
			"6": 0.047796,
			"7": 0.075108,
			"8": 0.040968,
			"9": 0.06828,
			"10": 0.047796,
			"11": 0.122904,
			"12": 0.10242,
			"13": 0.075108,
			"14": 0.088764,
			"15": 0.116076,
			"16": 0.027312,
			"17": 0.061452,
			"18": 0.006828,
			"19": 0.054624,
			"20": 0.088764,
			"21": 0.10242,
			"22": 0.081936,
			"23": 0.020484,
			"24": 0.054624,
			"25": 0.088764,
			"26": 0.006828,
			"27": 0.006828,
			"28": 0.054624,
			"29": null,
			"30": 0.013656,
			"31": 0.027312,
			"32": 0.047796,
			"33": 0.020484,
			"34": 0.020484,
			"35": 0.075108,
			"36": 0.075108,
			"37": 0.020484,
			"38": null,
			"39": 0.013656,
			"40": null,
			"41": 0.013656,
			"42": 0.040968,
			"43": 0.109248,
			"44": 0.013656,
			"45": 0.03414,
			"46": 0.040968,
			"47": 0.245808,
			"48": 0.122904,
			"49": 1.94598,
			"50": 0.03414,
			"51": null,
			"52": null,
			"3.5": 1.0242,
			"3.6": 2.103024
		},
		"opera": {
			"9": null,
			"11": 0.150216,
			"12": 1.242696,
			"15": null,
			"16": 0.03414,
			"17": 0.061452,
			"18": 0.081936,
			"19": 0.006828,
			"20": 0.177528,
			"21": 0.013656,
			"22": null,
			"23": 0.027312,
			"24": 0.081936,
			"25": 0.143388,
			"26": 0.088764,
			"27": 0.464304,
			"28": 0.006828,
			"29": 0.040968,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.013656,
			"35": null,
			"36": 0.157044,
			"37": 0.116076,
			"38": 0.040968,
			"39": 0.03414,
			"40": 1.918668,
			"41": 0.279948,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0.198012,
			"10.5": 0.054624,
			"10.6": 0.198012,
			"11.1": 0.150216,
			"11.5": 0.293604,
			"11.6": 0.505272,
			"12.1": 2.2191
		},
		"safari": {
			"0": null,
			"4": 0.320916,
			"5": 0.525756,
			"6": 0.061452,
			"7": 0.027312,
			"8": 0.027312,
			"9": 0.020484,
			"10": 0.471132,
			"3.1": 0.06828,
			"3.2": 0.027312,
			"5.1": 0.109248,
			"6.1": 0.006828,
			"7.1": 0.020484,
			"9.1": 0.184356
		},
		"ios_saf": {
			"8": 0,
			"10": 2.46249140383,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0663612939217,
			"8.1-8.4": 0.122599678601,
			"9.0-9.2": 0.0584879200666,
			"9.3": 0.89231570358
		},
		"android": {
			"3": 0,
			"4": 0.0439351472868,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00549189341085,
			"4.1": 0.158480352713,
			"4.2-4.3": 0.396200881783,
			"4.4": 0.908516081395,
			"4.4.3-4.4.4": 0.916361643411
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 1.14285316269,
			"9": 0.499525223427,
			"10": 0.68873932321,
			"11": 1.15042172668,
			"5.5": null
		},
		"op_mob": {
			"0": 0.391000819889,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0108611338858
		},
		"edge": {
			"12": 0.075108,
			"13": 0.10242,
			"14": 0.27312
		},
		"ie_mob": {
			"10": 0.0493961408451,
			"11": 0.201112859155
		},
		"bb": {
			"7": 0.00872025,
			"10": null
		},
		"samsung": {
			"0": 2.428986
		},
		"and_uc": {
			"0": 3.827397
		},
		"op_mini": {
			"0": 5.26788604622
		},
		"and_chr": {
			"0": 14.578113
		},
		"and_ff": {
			"0": 0.003171
		}
	},
	"total": 93.245429686
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/KG.json
 ** module id = 561
 ** module chunks = 0
 **/